import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as MoreCkStyles from '../../../styles/products/more-ck.module.scss';
import IconContainer from '../IconContainer';

const MoreDetails = ({ ...props }) => {
  const [display, setDisplay] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    setDisplay(!display);
  };

  return (
    <>
      <button className={MoreCkStyles.containerButton} onClick={handleClick}>
        <p className={MoreCkStyles.button}>{t('nav.seeMore')}</p>
        <IconContainer
          classname={MoreCkStyles.more}
          color="BLACK"
          icon={display ? 'ARROW_UP_SMALL' : 'ARROW_DOWN_SMALL'}
          noHover
          size={20}
        />
      </button>
      <p
        className={clsx('ckContent', { [MoreCkStyles.activeSub]: !display })}
        dangerouslySetInnerHTML={{ __html: props.data }}
      />
    </>
  );
};

MoreDetails.propTypes = {
  children: PropTypes.node,
  data: PropTypes.string,
};

export default MoreDetails;
